import React, { useState } from "react";
import Map from './Map'

const Slider = ({ electionData }) => {
  const [selectedYear, setSelectedYear] = useState(1976);
  const handleChange = (event) => {
    setSelectedYear(parseInt(event.target.value));
  };

  return (
    <>
    <div>
      <header className="d-flex justify-content-center py-3">
        <h2>How the US Voted in <span style={{ 'color': 'yellow' }}>{selectedYear}</span></h2>

      </header>
        <input
          type="range"
          className="form-range"
          min={1976}
          max={2020}
          step={4}
          value={selectedYear || ''}
          onChange={handleChange}
        />
      </div>
      <Map electionData = { electionData[0][selectedYear] } selectedYear = {selectedYear} />
    </>
  );
}

export default Slider;


